import React from "react";

// design
const CARD= { borderRadius: "8px", marginTop: "10px", boxShadow: "0 2px 6px rgba(0,0,0,0.10)" };
const HDR = { background: "#374151", padding: "8px 14px", display: "flex", alignItems: "center", gap: "8px", borderRadius: "8px 8px 0 0" };
const SECTION = { borderLeft: "1px solid #cbd5e1", borderRight: "1px solid #cbd5e1" };
const TITLE= { margin: 0, color: "white", fontSize: "13px", fontWeight: "600" };
const FOOTER = { ...SECTION, borderBottom: "1px solid #cbd5e1", borderRadius: "0 0 8px 8px", padding: "5px 14px 6px", background: "#f9fafb", borderTop: "1px solid #e5e7eb", fontSize: "10px", color: "#6b7280", display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "center" };

const TABLE_ROWS = [
    { label: "Participant No", key: "participantId" },
    { label: "Method A",       key: "valueA" },
    { label: "Method B",       key: "valueB" },
    { label: "Chosen Method",  key: "chosen" },
];

class RawData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showRaw: false // visibility toggle
        };
    }

    toggle = () => this.setState(prev => ({ showRaw: !prev.showRaw }));

    render() {
        const raw = this.props.data?.twoAfcData?.participantChoices || [];

        const HDR_CELL = {
            background: "#374151",
            color: "white",
            padding: "5px 8px",
            fontWeight: "600",
            fontSize: "10px",
            textAlign: "center",
            whiteSpace: "nowrap",
            borderRight: "1px solid #4b5563",
            position: "sticky",
            top: 0
        };
        const ROW_LABEL = {
            padding: "4px 10px 4px 14px",
            fontSize: "11px",
            fontWeight: "600",
            color: "#374151",
            background: "#f9fafb",
            borderRight: "2px solid #e5e7eb",
            borderBottom: "1px solid #e5e7eb",
            whiteSpace: "nowrap",
            position: "sticky",
            left: 0,
            zIndex: 1
        };
        const DATA_CELL = {
            padding: "4px 8px",
            fontSize: "10px",
            textAlign: "center",
            fontFamily: "monospace",
            borderRight: "1px solid #e5e7eb",
            borderBottom: "1px solid #e5e7eb",
            whiteSpace: "nowrap"
        };

        return (
            <div style={{ marginTop: "16px" }}>

                <button
                    onClick={this.toggle}
                    style={{
                        padding: "5px 14px",
                        fontSize: "12px",
                        fontWeight: "600",
                        border: "1px solid #cbd5e1",
                        borderRadius: "6px",
                        background: this.state.showRaw ? "#374151" : "white",
                        color: this.state.showRaw ? "white" : "#374151",
                        cursor: "pointer",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                        transition: "background 0.15s, color 0.15s",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px"
                    }}
                >
                    <span style={{ fontSize: "10px" }}>{this.state.showRaw ? "▲" : "▼"}</span>
                    {this.state.showRaw ? "Hide Raw Data" : "Show Raw Data"}
                </button>

                {raw.length > 0 && this.state.showRaw && (
                    <div style={CARD}>

                        <div style={HDR}>
                            <h4 style={TITLE}>Raw Pairwise Data</h4>
                        </div>

                        <div style={{ ...SECTION, padding: "4px 14px", background: "#f9fafb", borderBottom: "1px solid #e5e7eb", fontSize: "10px", color: "#6b7280" }}>
                            Each column is one comparison event.
                        </div>

                        <div style={{ ...SECTION, overflowX: "auto", overflowY: "auto", maxHeight: "220px", background: "white" }}>
                            <table style={{ borderCollapse: "collapse" }}>
                                <thead>
                                    <tr>
                                        <th style={{ ...HDR_CELL, textAlign: "left", paddingLeft: "14px", minWidth: "130px", position: "sticky", top: 0, left: 0, zIndex: 2 }}>
                                            Comparison #
                                        </th>
                                        {raw.map((_, i) => (
                                            <th key={i} style={{ ...HDR_CELL, minWidth: "38px", fontSize: "9px", color: "#d1d5db" }}>
                                                {i + 1}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {TABLE_ROWS.map((row, ri) => (
                                        <tr key={ri} style={{ background: ri % 2 === 0 ? "white" : "#fafafa" }}>
                                            <td style={ROW_LABEL}>{row.label}</td>
                                            {raw.map((entry, i) => {
                                                const val = entry[row.key];
                                                if (row.key === "participantId") {
                                                    return (
                                                        <td key={i} style={{ ...DATA_CELL, color: "#374151", fontWeight: "600" }}>
                                                            {val}
                                                        </td>
                                                    );
                                                }
                                                const isChosen = row.key === "chosen";
                                                const chosenA  = isChosen && entry.chosen === entry.valueA;
                                                const pillStyle = isChosen
                                                    ? { display: "inline-block", background: chosenA ? "#dbeafe" : "#fee2e2", border: `1px solid ${chosenA ? "#93c5fd" : "#fca5a5"}`, borderRadius: "4px", padding: "2px 6px", fontSize: "10px", color: chosenA ? "#1d4ed8" : "#b91c1c", fontFamily: "monospace", maxWidth: "90px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", verticalAlign: "middle", fontWeight: "600" }
                                                    : { display: "inline-block", background: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: "4px", padding: "2px 6px", fontSize: "10px", color: "#475569", fontFamily: "monospace", maxWidth: "90px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", verticalAlign: "middle" };
                                                return (
                                                    <td key={i} style={{ ...DATA_CELL, padding: "3px 6px" }}>
                                                        <span title={val} style={pillStyle}>{val}</span>
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div style={FOOTER}>
                            <span>Scroll horizontally to view all</span>
                            <span>|</span>
                            <span style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
                                <span style={{ width: "10px", height: "10px", background: "#2563eb", borderRadius: "2px", display: "inline-block" }} />
                                Method A chosen
                            </span>
                            <span>|</span>
                            <span style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
                                <span style={{ width: "10px", height: "10px", background: "#dc2626", borderRadius: "2px", display: "inline-block" }} />
                                Method B chosen
                            </span>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default RawData;
